// extracted by mini-css-extract-plugin
export var blueBanner = "terms-module--blueBanner--5wiH3";
export var container = "terms-module--container--LKmS2";
export var header = "terms-module--header---ZL7T";
export var main = "terms-module--main--lStMe";
export var mainPadding = "terms-module--mainPadding--XgcOg";
export var mainRaised = "terms-module--mainRaised--z7SXa";
export var section = "terms-module--section--NpPAA";
export var space150 = "terms-module--space150--HWj2C";
export var statement = "terms-module--statement--q-SUf";